
// src/reducers/alert-message-reducer.js

import { 
  EMIT_ALERT_MESSAGE,
  CLEAR_ALERT_MESSAGE,
  FADEOUT_ALERT_MESSAGE,
} from '../actions/alert-message';
import {
  CLEAR_LOGIN_STATUS,
} from '../actions/sessions'

const initialState = {
  message: undefined,
  category: undefined,
  trial_expired: undefined,
  re_trial: undefined,
};

export default function alertMessageReducer(state = initialState, action = {}) {
  switch(action.type) {
  case EMIT_ALERT_MESSAGE:
    return Object.assign({}, state, {
      message: action.message,
      category: action.category,
      trial_expired: action.trial_expired,
      re_trial: action.re_trial,
    });

  case CLEAR_LOGIN_STATUS:
  case CLEAR_ALERT_MESSAGE:
    return Object.assign({}, state, {
      message: undefined,
      category: undefined,
      trial_expired: undefined,
      re_trial: undefined,
    });

  default:
    return state;
  }
}




// WEBPACK FOOTER //
// ./src/reducers/alert-message-reducer.js